import { render, staticRenderFns } from "./SettingAudienceAdmission.vue?vue&type=template&id=5169e744&scoped=true&"
import script from "./SettingAudienceAdmission.vue?vue&type=script&lang=js&"
export * from "./SettingAudienceAdmission.vue?vue&type=script&lang=js&"
import style0 from "./SettingAudienceAdmission.vue?vue&type=style&index=0&id=5169e744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5169e744",
  null
  
)

export default component.exports